module.exports = __webpack_public_path__ + "static/certificate1-829405129e3b77e0d9b553a6287309b8.jpg";